 <template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head">Sales</span>
            <small></small>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="alert alert-success" v-if="haserror.message!=''" style="text-align:center;">{{haserror.message}}</div>
              </div>
            </div>
            <b-row>
              <b-col sm="4">
                <b-form-group>
                  <label for="name">Customer Name </label>
                  <span style="display: flex;">
                    <!--
                    <model-list-select :list="customername" option-value="customer_id" :custom-text="nameAndnumber" v-model="selectedcustomer" placeholder="Search Customer Name" @input="onSelectCust($event, true)" @searchchange="searchcustomer" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
                    &nbsp;&nbsp;--><!--<button type="button" class="btn btn-pill btn-primary" route v-b-tooltip.hover title="Add New Customer" @click="addCustomer()"><i class="fa fa-user"></i></button>-->
                    <input type="text" class="form-control" id="cust_name" name="txtCustName" v-model="selectcustname" autocomplete="off" :disabled=true>
                  </span>
                    <!--<small  class="form-text text-muted"><strong style="color: red;">{{haserror.cust}}</strong></small>-->
                  </b-form-group>
                </b-col>

                <b-col sm="4">
                  <b-form-group>
                    <label for="name">Shop Name </label>
                    <span style="display: flex;">
                      <input type="text" class="form-control" id="shop_name" name="txtShopName" v-model="selectshopname" autocomplete="off" :disabled=true>
                      <!--
                        <model-list-select @input="onSelectShp($event)" :list="shopname" option-value="est_shop_id" option-text="est_shop_name" v-model="selectshop" placeholder="Select Shop" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select> 
                        <button type="button" @click="addShop()" class="btn btn-pill btn-primary" v-b-tooltip.hover title="Add New Shop"><i class="fa fa-plus"></i></button>-->
                      </span>
                      <!-- <a><small class="form-text text-muted" @click="smallmodal1 = true"><strong style="color: blue;">Click here to edit shop</strong></small></a> -->
                      <!--<small class="form-text text-muted"><strong style="color: red;">{{haserror.shop}}</strong></small>-->
                    </b-form-group>
                  </b-col>
                  <b-col sm="2">
                    <b-form-group>
                      <label for="name">Barcode</label>
                      <!-- <input type="text" class="form-control" name="barcode" v-model="barcode" @blur="searchBarcode" @keyup="checkShop" placeholder="Enter Barcode">&nbsp;&nbsp; -->
                      <input type="text" class="form-control" name="barcode" v-model="barcode" @blur="searchBarcode" placeholder="Enter Barcode">&nbsp;&nbsp;
                      <small class="form-text text-muted"><strong style="color: red;">{{haserror.barcode}}</strong></small>
                    </b-form-group>
                  </b-col>
                  <b-col sm="2">
                  <b-form-group>
                    <label for="name">Sale Entry Date</label>
                    <date-picker v-model="saleentry_dt" input-name="date" format="YYYY-MM-DD" editable lang="en" :not-before="disabledBefore" :not-after="disabledAfter" style="width: 0px; min-width: 155px;"></date-picker>
                  </b-form-group>
                </b-col>
                </b-row>
                <b-row>
                  <b-col sm="4">
                    <h6 class="my-3">
                      Ship To:<small class="printpage"><i class="fa fa-edit" @click.prevent="addressModel =true"></i></small>
                    </h6>
                    <div>
                      <strong>{{ customer1.name }} &nbsp; {{ customer1.phone }}</strong>
                    </div>
                    <div>{{ customer1.gst }}</div>
                    <div>{{ customer1.add }}</div>
                    <div>
                      {{ customer1.city }} {{ customer1.state }}
                      {{ customer1.pincode }}
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="card">
              <div class="card-header title_head">
                ITEM DETAILS
              </div>
              <div class="card-body" style="padding:0px !important;">

                <table class="table table-striped table-responsive">
                  <thead>
                    <tr style="font-size: 12px; text-align: center;">

                      <th width="20%">Product Name</th>
                      <th width="8%">Unit</th>
                      <th width="9%">Qty</th> 
                      <th width="12%">Sale Price/Unit</th> 
                      <th width="12%">Amt Before Tax</th> 
                      <th width="6%" v-show="is_cs_gst">SGST %</th> 
                      <th width="6%" v-show="is_cs_gst">CGST %</th>            
                      <th width="6%" v-show="is_i_gst">IGST %</th> 
                      <th width="14%">Total</th>
                      <th width="6%">Other</th>
                    </tr>
                  </thead> 
                  <input type="hidden" name="qty1" id="qty1" value=""> 
                  <tbody id="product_table_body">

                   <tr v-for="(row, index) in rows">
                     <td>
                      <model-list-select :list="row.productnamex" option-value="product_id" option-text="product_name" v-model="row.selectproductrow" placeholder="Search Product Name" @input="openvariant($event,index)" @searchchange="searchprd3($event,index,row)" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:30px !important; border: 1px solid rgb(194, 207, 214);min-height: 30px; border-radius: 1px; padding-top: 6px;" class="product-drop">
                      </model-list-select>
                      <small style="font-size:  10px;color: red; cursor:pointer;"  @click="openvariant(row,index)">Variant :<i class="fa fa-info-circle"></i> {{row.variantrow}} </small>
                    </td>
                    <td>
                      <input class="form-control-sm" disabled="disabled" type="text" v-model="row.unit"  style="width: 100%;">
                    </td>
                    <td>

                      <input type="text" class="form-control-sm" v-model="row.qty" style="width: 100%;" v-on:change="price(index);"><br>
                      <small style="font-size: 10px; color: red;" v-if="row.err_qty!=''">{{row.err_qty}}<br></small>
                      <small style="font-size:  10px;color: green;margin-top: 41px;">Available Qty:{{row.avaqty}}</small>
                    </td> 
                    <td>
                      <input type="text" style="width: 100%;" v-model="row.price" class="form-control-sm"  v-on:change="price(index);"></br>
                      <small style="font-size: 10px; color: red;" v-if="row.err_price!=''">{{row.err_price}}<br></small>
                      <small style="font-size:  10px;color: green;margin-top: 41px;">Price:{{row.priceqty}}</small>

                    </td>  
                    <td>
                      <input type="text" style="width: 100%;" class="form-control-sm" v-model="row.amt" disabled="" >
                    </td>
                    <td v-show="is_cs_gst">
                      <!-- <input type="text" style="width: 100%;"  class="form-control-sm" v-model="row.sgst" v-on:change="price(index);"> -->
                      <input type="text" style="width: 100%;" :disabled="csgstdisable" class="form-control-sm" v-model="row.sgst" v-on:change="price(index);">
                      <small style="font-size: 10px; color: red;" v-if="row.err_sgst!=''">{{row.err_sgst}}<br></small>
                    </td>  
                    <td v-show="is_cs_gst">
                      <!-- <input type="text" style="width: 100%;"  class="form-control-sm" v-model="row.cgst"  v-on:change="price(index);" > -->
                      <input type="text" style="width: 100%;" :disabled="csgstdisable" class="form-control-sm" v-model="row.cgst" v-on:change="price(index);">
                      <small style="font-size: 10px; color: red;" v-if="row.err_cgst!=''">{{row.err_cgst}}<br></small>
                    </td> 

                    <td v-show="is_i_gst">
                      <!-- <input type="text" style="width: 100%;"   class="form-control-sm" v-model="row.igst"  v-on:change="price(index);"> -->
                      <input type="text" style="width: 100%;" :disabled="igstdisable" class="form-control-sm" v-model="row.igst" v-on:change="price(index);">
                      <small style="font-size: 10px; color: red;" v-if="row.err_igst!=''">{{row.err_igst}}<br></small>
                    </td> 
                    <td>
                      <input type="text" disabled="disabled"  v-model="row.amttotal" style="width: 100%;" class="form-control-sm">
                    </td>
                    <td>
                      <center>
                        <i class="fa fa-reorder" style="color: #20a8d8;" v-b-tooltip.hover title="Add More option" variant="secondary" @click="openmodal(index)"></i>
                        <i class="fa fa-trash-o" style="color: #F44336;" v-b-tooltip.hover title="Delete" v-on:click="removeElement(row,index);"></i>
                      </center>              
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div style="font-size:  13px;color: green;">Add New Row: 
                       <span style="cursor:  pointer;" @click="addRow1" class="badge badge-pill badge-info" v-b-tooltip.hover title="Add New Row">Add</span></div>
                     </td>
                     <td colspan="9" style="text-align: right;">Total Items Discount</small>: 
                      <input type="text" class="form-control-sm" disabled="" :value="totaldis" > 
                    </td> 
                  </tr>

                  <tr>
                    <td></td>
                    <td colspan="9" style="text-align: right;">Additional Discount: <input type="" v-on:change="discountadd" class="form-control-sm" v-model="detail.addition"></td> 
                  </tr>

                  <tr>
                    <td></td>
                    <td colspan="9" style="text-align: right;">Total Amount Before Tax: <input type="" :value="totalamt" class="form-control-sm" disabled=""></td> 
                  </tr>
                  <tr  v-if="is_cs_gst">
                    <td></td>
                    <td colspan="9" style="text-align: right;">SGST: <input class="form-control-sm" type="text" disabled=""  :value="totalsgst"></td> 
                  </tr>

                  <tr v-if="is_cs_gst">
                    <td></td>
                    <td colspan="9" style="text-align: right;" >CGST: <input type="text" class="form-control-sm" disabled=""  :value="totalcgst"></td> 
                  </tr>

                  <tr  v-if="is_i_gst">
                    <td></td>
                    <td colspan="9" style="text-align: right;">IGST: <input type="text" class="form-control-sm" disabled=""  :value="totaligst"></td> 
                  </tr>
                  <tr>
                    <td style="text-align: left;">Payment: </td>
                    <td style="text-align: left;">
                      <b-form-select v-model="selected_pytype" :options="lst_paymenttype" v-on:change="paychange"></b-form-select>
                    </td>
                    <td  colspan="8" style="text-align: right;">Total Tax Amount: <input type="text" :value="totaltax" disabled="" class="form-control-sm"></td> 
                  </tr> 
                  <tr> 
                    <td colspan="3" style="text-align: left;">
                      <b-form-group label="">
                        Payment Mode:
                        <b-form-radio v-model="selected_pymode" name="payment_mode" value="cash" v-on:change="modechange">Cash</b-form-radio>
                        <b-form-radio v-model="selected_pymode" name="payment_mode" value="cheque" v-on:change="modechange">Cheque</b-form-radio>
                      </b-form-group>
                    </td>
                    <td colspan="7" style="text-align: right;">Total Amount To Pay: <input type="text" :value="totalamtpay" disabled="" class="form-control-sm"><br>
                <small style="font-size: 10px; color: red;" v-if="err_totamtpay != ''" >{{err_totamtpay}}</small></td> 
                  </tr> 
                  <tr v-if="fullpay === true">
                    <td></td>
                    <td colspan="9" style="text-align: right;">Amount Received: <input type="text" v-on:change="calchnge();" class="form-control-sm" v-model="totalamtreceived" :disabled="totamtrecdis"><br>
                    <small style="font-size: 10px; color: red;" v-show="fullamt_rec != ''" >{{fullamt_rec}}</small>
                  </td> 
                  </tr>
                  <tr v-if="fullpay === true">
                    <td></td>
                    <td colspan="9" style="text-align: right;">Change: <input type="text" class="form-control-sm" disabled="" v-model="chng"></td> 
                  </tr>
                  <tr v-if="parpay === true">
                    <td></td>
                    <td colspan="9" style="text-align: right;">Amount Received: <input type="text" class="form-control-sm" v-model="totalparamtreceived" v-on:change="calbalance();"><br>
                      <small style="font-size: 10px; color: red;" v-if="amt_rec != ''" >{{amt_rec}}</small>
                    </td> 
                  </tr>
                  <tr>
                    <td></td>
                    <td colspan="9" style="text-align: right;">Previously Paid Amount: <input type="text" class="form-control-sm"
                        v-model="totalamtpreviouspaid" disabled=""><br>
                      <!-- <small style="font-size: 10px; color: red;" v-if="amt_rec != ''">{{amt_rec}}</small> -->
                    </td>
                  </tr>
                  <tr v-if="parpay === true">
                    <td></td>
                    <td colspan="9" style="text-align: right;">Balance: <input type="text" class="form-control-sm" disabled="" v-model="bal"></td> 
                  </tr>
                  <tr v-if="chqpay === true">
                    <td></td>
                    <td colspan="9" style="text-align: right;">Cheque No.: <input type="text" name="cheque_no" autocomplete="off" v-model="cheque_no" class="form-control-sm" placeholder="Enter Cheque No"><br>
                      <small style="font-size: 10px; color: red;" v-if="chequeno_validate != ''" >{{chequeno_validate}}</small>
                    </td> 
                  </tr>
                  <tr v-if="chqpay === true">
                    <td></td>
                    <td colspan="9" style="text-align: right;">Cheque Date.: <date-picker v-model="cheque_date" editable lang="en" class="form-control-sm"></date-picker><br>
                     <small style="font-size: 10px; color: red;" v-if="chequedate_validate != ''" >{{chequedate_validate}}</small>

                   </td> 
                 </tr> 
               </tbody>
             </table>




             <b-modal title="Add More Option" no-close-on-esc no-close-on-backdrop v-model="largeModal"  hide-footer @ok="largeModal = false">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">Discount Percentage:</label>
                    <input type="text" class="form-control" name="cmp_phone" v-model="percentagemd" placeholder="Enter Discount Percentage"  >
                    <small  class="form-text text-muted"  ><strong style="color: red;">{{haserror.dis}}</strong></small>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">Discount Amount :</label>
                    <input type="text" class="form-control" id="cmp_email" v-model="amtmd" name="cmp_email" placeholder="Enter Discount Amount"  >
                    <small  class="form-text text-muted"  ><strong style="color: red;">{{haserror.amt}}</strong></small>
                  </div>
                </div>
              </div>
              <div class="row">f
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">Tax Inclusive:</label>
                    <input type="checkbox" name="cmp_inclusive" v-model="inclusive">
                    <small class="form-text text-muted"><strong style="color: red;">{{haserror.inclusive}}</strong></small>
                  </div>
                </div>
              </div>               
              <button type="submit" class="btn btn-sm btn-primary"  @click="savemodal(indexval)">
                <i class="fa fa-dot-circle-o"></i> Save</button>
              </b-modal>

              <!-- change shop -->
              <b-modal title="Select Shop" no-close-on-esc no-close-on-backdrop size="lg" v-model="smallmodal1"  hide-footer @ok="smallmodal1 = false">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <model-list-select :list="shopname" option-value="est_shop_id" option-text="est_shop_name"  v-model="selectshop" placeholder="Search Shop"></model-list-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <button type="button" class="btn btn-warning pull-right" @click="updateshop()"> Update Shop</button>
                    </div>
                  </div>
                </div>
              </b-modal>
              <!-- end  -->

              <!-- changes in popup modal -->
              <b-modal title="Select Variant" size="sm" no-close-on-esc no-close-on-backdrop v-model="smallmodal"  hide-footer @ok="smallmodal = false">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <model-list-select :list="variantvalue" class="form-control-sm" option-value="variant_value" option-text="variant_value" v-model="variantdata" placeholder="Search Variant Value" @input="onSelectvariant($event)" style="width: 100%;"></model-list-select>
                    </div>
                  </div>
                </div>
              </b-modal>
              <!-- end  -->
            </div>
            <div class="card-footer">
              <button type="submit" class="btn btn-sm btn-primary" @click="finalsubmit('')"><i class="fa fa-dot-circle-o"></i> Save</button>&nbsp;&nbsp;&nbsp;&nbsp;
              <button type="submit" class="btn btn-sm btn-primary" @click="finalsubmit('inv')"><i class="fa fa-dot-circle-o"></i> Save And Generate Invoice</button>
            </div>
          </div>
        </div>
      </div>
      <b-modal title="Shipping Details" hide-footer size="lg" v-model="addressModel" @ok="addressModel = false">
        <div class="row" v-for="(address1, index) in addr">
          <div class="col-sm-10">
            <div class="form-group">
              <b>{{address1.yname}}&nbsp;({{address1.yphn}})</b><br>
              <b>{{address1.ygst}}</b><br>
              <span v-if="address1.yaddress!=''">
                {{address1.yaddress}}<br></span>
              <span v-if="address1.ystate != '' && address1.ycity != '' && address1.ypincode != ''">
                {{address1.ystate}} &nbsp; {{address1.ycity}} - {{address1.ypincode}}
              </span>
            </div>
          </div>
          <div class="col-sm-2" style="color:#f86c6b;font-size: 20px; cursor: pointer;">
            <span>
              <small> <i @click="showAddress(address1)" class="fa fa-plus"
                  style="color:#34a8d8;cursor:pointer;">Add</i></small>
            </span>
          </div>
          <hr width="97%">
        </div>
      </b-modal>
      <Spinner v-if="loading"></Spinner>
    </div>
  </template>

  <script>
    import Spinner from '../../spinner.vue'
    import DatePicker from 'vue2-datepicker'
    export default {
      components: {
        'date-picker':  DatePicker,
        Spinner
      },
      data () {
        return {
          disabledBefore: null,
          disabledAfter: null,
          saleentry_dt:'',
          totamtrecdis:false,
          ship_id:null,
          csgstdisable:true,
          igstdisable:true,
          addr: [],
          addressModel: false,
          all_unit:null,
          loading:false,
          amt_rec:'',
          err_totamtpay:'',
          fullamt_rec:'',
          chequeno_validate:'',
          chequedate_validate:'',
          variantindex:null,
          smallmodal1:false,
          smallmodal:false,
          fullpay:true,
          chqpay:false,
          parpay:false,
          chng:0,
          bal:0,
          total_amt_paid:0.00,
          totalamtreceived:'',
          totalamtpreviouspaid:0.00,
          totalparamtreceived:'',
          cheque_no:'',
          cheque_date:'',
          variantvalue:[],
          tempArr:[],
          variantdata:null,
          oldshp:null,
          old_shop_id:null,
          percentagemd:'',
          amtmd:'',
          barcode:'',
          inclusive:false,
          indexval:null,
          allproduct:[],
          largeModal:false,
          customername:[],
          selected_pytype:'full',
          lst_paymenttype:[
          { value: 'full', text: 'Full' },
          { value: 'partial', text: 'Partial' },
          { value: 'no', text: 'No' },
          ],
          selected_pymode:'cash',
          selectedcustomer:null,
          shopname:[],
          selectshop:null,
          selectshopname:null,
          selectcustname:null,
          productname:[],
          lst_prod_var:[],
          remove_rows:[],
          selectproduct:{},
          is_cs_gst:true,
          is_i_gst:true,
          sales_id:'',
          company_gst:null,
          customer_gst:null,
          rows:[],
          haserror:{
            amt:'',
            dis:'',
            // cust:'',
            message:'',
            inclusive:''
            // shop:''
          },
          customer1: {
            name: null,
            add: null,
            city: null,
            state: null,
            pincode: null,
            phone: null,
          },
          detail:{
            totprddis:'',
            addition:'',
            tot:'',
            cgst:'',
            sgst:'',
            igst:'',
            taxamt:'',
            totalamtpay:'',
            totalamtpendingpay:'',
          }
        }
      },
      computed: {
        totaldis() {
          var all =this.rows.reduce((total,row) => {
            if(Number(row.amtmd1)==0){
              return total +  (Number(row.qty)*Number(row.price)*Number(row.percentagemd1))/100;
            }else{
              return total +  (Number(row.amtmd1));
            }
          }, 0);
          all = all.toFixed(4);
          this.detail.totprddis=all;
          return all;
        },
        totalamt() {
          var all =this.rows.reduce((total,row) => {

            return total +  Number(row.amt);
          }, 0);
          all = all.toFixed(4);
          this.detail.tot=all;
          return all;
        },

        totalcgst() {
          var all =this.rows.reduce((total,row) => {
            return total +  ((Number(row.cgst)*Number(row.amt))/100);
          }, 0);
          all = all.toFixed(4);
          this.detail.cgst=all;
          return all;
        },
        totalsgst() {
          var all =this.rows.reduce((total,row) => {
            return total +  ((Number(row.sgst)*Number(row.amt))/100);
          }, 0);
          all = all.toFixed(4);
          this.detail.sgst=all;
          return all;
        },
        totaligst() {
          var all =this.rows.reduce((total,row) => {
            return total +  ((Number(row.igst)*Number(row.amt))/100);
          }, 0);
          all = all.toFixed(4);
          this.detail.igst=all;
          return all;
        },
        totaltax() {
          var all =this.rows.reduce((total,row) => {
            return total +  (Number(row.amttotal)-Number(row.amt));
          }, 0);
          all = all.toFixed(4);
          this.detail.taxamt=all;
          return all;
        },
        totalamtpay(){
          var all =this.rows.reduce((total,row) => {
            return total +  (Number(row.amttotal));
          }, 0);
          all = all.toFixed(4);
          if(this.detail.addition==''){
            this.detail.totalamtpay=all;
            return all
          }else{
            this.detail.totalamtpay=all-parseFloat(this.detail.addition);
            return all-parseFloat(this.detail.addition);
          }
        }
      },

      created(){
        for (var i = 0; i <2; i++) {
          var prodlst = []
          prodlst = this.allproduct
          this.rows.push({ productnamex:[],selectedproductid:null,unit:'',selectproductrow:null,price:'', qty:'',amt:'', cgst:0, sgst:0, igst:'',amttotal:0, percentagemd1:'', amtmd1:'',avaqty:'',variantrow:'n/a',show:false,priceqty:'', inclusive1:false, err_qty:'', err_price:'', err_sgst:'', err_cgst:'', err_igst:'',productExist:'',item_seq:''})
        }
        var current_dt = new Date()
        var before_180 = new Date(current_dt.valueOf())
        var after_180 = new Date(current_dt.valueOf())
        before_180.setDate(before_180.getDate() - 180)
        after_180.setDate(before_180.getDate() + 180)
        this.disabledBefore = before_180
        this.disabledAfter = after_180
        this.shopuser();
        Promise.all([this.searchcustomer(),this.searchshops(),this.listProduct(),this.getUnit()]).then(ret_val => {
          this.showSaleItems(); 
        });
      },

      methods:{

    //   addProduct() {
    //   var _this = this
    //   this.$http.get('/api/companyproducts/loadData').then(function (response){
    //     if(response.data.data){
    //       _this.$addproductmodal.show(response.data.data);
    //     }
    //   }).catch(function(error){
    //       console.log(error)
    //       if (error.response.status === 401) {
    //         localStorage.clear();
    //         _this.$store.commit('SET_AUTH_USER', null)
    //         _this.$router.push('/');
    //       }
    //       if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
    //         localStorage.clear();
    //         _this.$store.commit('SET_AUTH_USER', null)
    //         _this.$router.push('/');
    //       }
    //     });
    // },

    // addCustomer(){
    //     console.log('addCustomer')
    //     var params = {}
    //     var _this = this
    //     this.$http.get('/api/countries').then(function(countries){
    //     params["conopt"] = countries.data;
    //     var __this = _this
    //     _this.$http.get('/api/companytypes').then(function(response){
    //       params["contyp"] = response.data;
    //       __this.$addcustomermodal.showCustomer(params);
    //     }).catch(function(err){
    //       console.log(err)
    //     })

    //   }).catch(function(error){
    //     console.log(error)
    //   })
    //   },
      // addShop(){
      // var _this=this
      //   var params = {}
      //   this.$http.get('/api/countries').then(function(countries){
      //     params['countries'] = countries.data
      //     _this.$addshopmodal.showShop(params);
      //     var __this = _this
      //     var timer = setInterval(function(){
      //        var modal_return = __this.$store.getters.get_shopmodal;
      //         if(modal_return !== null){
      //           console.log(modal_return);
      //           // __this.selectshop = modal_return  
      //           __this.searchshops()
      //           clearInterval(timer);
      //         }
      //     }, 1000);
      //   }).catch(function(error){
      //     console.log("error - " + error)
      //   })
      // },
      async getUnit(){
        var _this = this
        this.$http.get('/api/Unittypes/getUnit').then(function(response){
          // console.log(response)
          _this.all_unit = response.data.data
          if(_this.all_unit !== null){
            return Promise.resolve(true);
          }
        });
      },
      showAddress(adrs) {
        this.customer1.name = adrs.yname
        this.customer1.add = adrs.yaddress
        this.customer1.city = adrs.ycity
        this.customer1.phone = adrs.yphn
        this.customer1.state = adrs.ystate
        this.customer1.pincode = adrs.ypincode
        this.customer1.gst = adrs.ygst
        this.customer1.ship_id = adrs.chkship_id
        this.addressModel = false
        this.is_cs_gst = true
        this.is_i_gst = true
        this.customer_gst = this.customer1.gst
        if(this.company_gst && this.customer_gst){
          var company_gst = this.company_gst.substring(0, 2)
          var customer_gst = this.customer_gst.substring(0, 2)
          if(company_gst === customer_gst){
            this.is_cs_gst = true
            this.is_i_gst = false
            this.csgstdisable = true
          }else{
            this.is_cs_gst = false
            this.is_i_gst = true
            this.igstdisable = true
          }
        }else if(this.company_gst){
          this.is_cs_gst = true
          this.is_i_gst = true
          this.csgstdisable = false
          this.igstdisable = false
        }else if(!this.company_gst){
          this.is_cs_gst = false
          this.is_i_gst = false
        }
          
        // if(this.rows.length > 0){
        //   for (var i = 0; i < this.rows.length; i++) {
        //     var tax_id = typeof this.rows[i].selectproductrow === 'object' ? this.rows[i].selectproductrow.tax_gst_id : this.rows[i].productdetails[0].tax_gst_id
        //     this.set_tax(tax_id,i)
        //   }
        // }
        this.set_taxforall()
      },
      calchnge(){
        var regexp = /^[1-9]\d*(\.\d+)?$/
        if(this.totalamtreceived !== ''){
          if(regexp.test(this.totalamtreceived) === false){
            alert('Please Enter Valid Amount')
            this.totalamtreceived = ''
            return
          }else{
            if(parseFloat(this.totalamtpay) == parseFloat(this.totalamtpreviouspaid)){
              this.totalamtreceived = ''
              this.fullamt_rec = 'Already Paid'
            }
            else{
              var paid = parseFloat(this.totalamtreceived) + parseFloat(this.totalamtpreviouspaid)
              this.chng = ((paid).toFixed(4) - parseFloat(this.detail.totalamtpay))
            }
          }
        }
      },

      calbalance(){
        var regexp = /^[1-9]\d*(\.\d+)?$/
        if(this.totalparamtreceived !== ''){
          if(regexp.test(this.totalparamtreceived) === false){
            alert('Please Enter Valid Amount')
            this.totalparamtreceived = ''   
            return
          }else{
            // this.bal = (parseFloat(this.detail.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(2)
            var paid = parseFloat(this.totalparamtreceived) + parseFloat(this.totalamtpreviouspaid)
            this.bal = (parseFloat(this.detail.totalamtpay) - paid).toFixed(4)
          }
        }
      },

      paychange(select_paytype_val){
        this.selected_pytype = select_paytype_val
        this.fullpay = false
        this.parpay = false
        if(this.selected_pytype === 'full'){
          this.fullpay = true
          this.totalamtreceived = parseFloat(this.totalamtpay) - parseFloat(this.totalamtpreviouspaid)
          if(this.selected_pymode == 'cheque'){
            this.chqpay = true
          }
          else{
            this.chqpay = false
          }
        }
        else if(this.selected_pytype === 'partial'){
          this.parpay = true
          if(this.selected_pymode == 'cheque'){
            this.chqpay = true
          }
          else{
            this.chqpay = false
          }
        }
        else{
          this.chqpay = false
        }
      },

      modechange(select_paymode_val){
        this.selected_pymode = select_paymode_val
        if(this.selected_pytype !== 'no'){
          if(this.selected_pymode == 'cheque'){
            this.chqpay = true
          }
          else{
           this.chqpay = false 
           this.cheque_no = ''
           this.cheque_date = ''
         }
       }
       else{
        this.chqpay = false
        this.cheque_no = ''
        this.cheque_date = ''
      }
    },

    showSaleItems(){
      this.rows.length = 0
      var _this = this
      this.totalamtreceived = ''
      this.sales_id = JSON.parse(localStorage.getItem('sales_id'))
      _this.$http.get('/api/saledetails?filter[where][sales_id]='+_this.sales_id).then(function (res) {
        _this.$http.get('/api/sales?filter[where][sales_id]='+_this.sales_id).then(function (response) {
          if(response.data[0]){
            var select_shop = _this.shopname.filter(function(each){
              return each.est_shop_id === response.data[0].est_shop_id
            });
            _this.selectshop = select_shop[0]
            _this.old_shop_id = response.data[0].est_shop_id
            _this.selectshopname = _this.selectshop.est_shop_name
            var select_cust = _this.customername.filter(function(each){
              return each.customer_id === response.data[0].customer_id
            });
            _this.selectedcustomer = select_cust[0]
            _this.selectcustname = _this.nameAndnumber(_this.selectedcustomer)
            if(res.status === 200){
              _this.saleentry_dt = res.data[0].sale_entry_date
              _this.ship_id = res.data[0].ship_id
              _this.detail.totalamtpendingpay = res.data[0].total_amt_pendingpay  
              _this.detail.addition = parseFloat(res.data[0].additional_discount).toFixed(4)
              if(parseFloat(res.data[0].total_amt_pay) === parseFloat(res.data[0].total_amt_pendingpay)){
                _this.selected_pytype = 'no'
                _this.parpay = false
                _this.fullpay = false
              }
              else{
                _this.$http.get('/api/salepayments?filter[where][sale_id]='+_this.sales_id+'&filter[where][customer_id]='+_this.selectedcustomer.customer_id+'&filter[where][est_shop_id]='+_this.selectshop.est_shop_id).then(function (r){
                  if(r.status == 200){
                    var totamtprepaid = '';
                    totamtprepaid = r.data.reduce(function (last, d) { return parseFloat(d.amount) + parseFloat(last) }, 0.0);
                     _this.totalamtpreviouspaid = totamtprepaid.toFixed(4)
                  // _this.selected_pymode = r.data[0].payment_mode
                  //   if(_this.selected_pymode == 'cheque'){
                  //     _this.chqpay = true
                  //     _this.cheque_no = r.data[0].cheque_no
                  //     _this.cheque_date = r.data[0].cheque_date
                  //   }
                  //   else{
                  //    _this.chqpay = false
                  //    _this.cheque_no = ''
                  //    _this.cheque_date = ''
                  //  }

                    if(parseFloat(res.data[0].total_amt_pendingpay) === 0.00){
                    _this.selected_pytype = 'full'
                    _this.parpay = false
                    _this.fullpay = true
                    // _this.totalamtreceived = parseFloat(r.data[0].amount).toFixed(2)
                    // _this.totalamtpreviouspaid = parseFloat(r.data[0].amount).toFixed(2)
                  }
                  else{
                    _this.selected_pytype = 'partial'
                    _this.parpay = true
                    _this.fullpay = false
                    // _this.totalparamtreceived = parseFloat(r.data[0].amount).toFixed(2)
                    _this.bal = parseFloat(res.data[0].total_amt_pendingpay).toFixed(2)
                  }
                }
              });
              }
            }
            var api_filter = ''
            var len = parseInt(response.data.length)
            if(len > 1){
              for(var k=0; k<len;k++){
                api_filter = api_filter + '&filter[where][product_id][inq]='+response.data[k].product_id+'&filter[where][variant_id][inq]='+response.data[k].variant_id
              }
            }
            else{
              for(var k=0; k<len;k++){
                api_filter = api_filter + '&filter[where][product_id]='+response.data[k].product_id+'&filter[where][variant_id]='+response.data[k].variant_id
              }
            }
          // _this.$http.get('/api/estshopinventories?filter[where][product_id][inq]='+response.data[i].product_id+'&filter[where][est_shop_id]='+_this.selectshop.est_shop_id+'&filter[where][variant_id]='+response.data[i].variant_id).then(function (rr){
            _this.$http.get('/api/estshopinventories?filter[where][est_shop_id]='+_this.selectshop.est_shop_id+api_filter).then(function (rr){
            var inv_data = {}
            for(var j=1;j<parseInt(rr.data.length);j++){
              let temp = {'avaqty': 0, 'price': 0}
              temp['avaqty'] = rr.data[j].quantity
                  // temp['price'] = rr.data[j].last_purprice_aft
                  temp['price'] = rr.data[j].exp_sellprice_bft
                  inv_data[rr.data[j].product_id + '_' + rr.data[j].variant_id] = temp
                }
                // console.log(inv_data)
              // _this.selectshop = response1.data[0]
              // var data1={}
              // data1.customer_id = response.data[0].customer_id
              // _this.$http.post('/api/customers/shp_customer',data1) .then(function (response2) {
                // _this.selectedcustomer = response2.data[0]\
                for(var i=0;i<len;i++){
                  var each = response.data[i]
                // let avqty = rr.data.length == 1 ? '0' : rr.data[1].quantity 
                // let price =  rr.data.length == 1 ? '0' : rr.data[1].last_purprice_aft 
                let key = each.product_id + '_' + each.variant_id
                var avqty = 0
                var price = 0
                if(key in inv_data){
                  avqty = inv_data[each.product_id + '_' + each.variant_id]['avaqty'] 
                  price = inv_data[each.product_id + '_' + each.variant_id]['price']
                }
                var prdctdetails = _this.allproduct.filter(function(item){ return item.product_id === response.data[i].product_id; });
                var disc_pct = ''
                if(parseFloat(each.disc_pct).toFixed(2) !== '0.00'){
                  disc_pct = parseFloat(each.disc_pct)
                }
                var disc_amt = ''
                if(parseFloat(each.disc_amt).toFixed(2) !== '0.00'){
                  disc_amt = parseFloat(each.disc_amt).toFixed(4)
                }
                _this.rows.push({productnamex:prdctdetails,selectedproductid:each.product_id,unit:_this.all_unit[each.unit_id],selectproductrow:prdctdetails[0],price:parseFloat(each.product_unit_cost).toFixed(4), qty:each.sale_qty,amt:parseFloat(each.amt_before_tax).toFixed(4), cgst:parseFloat(each.cgst_amt).toFixed(4), sgst:parseFloat(each.sgst_amt).toFixed(4),igst:parseFloat(each.igst_amt).toFixed(4),amttotal:parseFloat(each.amt_to_pay).toFixed(4),percentagemd1:disc_pct, amtmd1:disc_amt,variantrow:each.variant_id,avaqty:avqty,priceqty:price, inclusive1:each.tax_inclusive, err_qty:'', err_price:'', err_sgst:'', err_cgst:'', err_igst:'',productExist:'',productdetails:prdctdetails[0],item_seq:each.item_seq,sales_id:each.sales_id,id:each.id})
              }
              _this.company_gst = _this.selectshop.shop_gst
              _this.onSelectCust(_this.selectedcustomer, false)
              })
            }else{
              _this.$router.push('/sales/salesentry')
            }
          });
        }).catch(function(er){
          console.log(er);
        });
      },

      async listProduct(){
        var _this = this
        var response = await this.$http.get('/api/companyproducts')
        _this.allproduct=response.data
        if(_this.allproduct.length > 0){
          return Promise.resolve(true);
        }
      },

      // checkShop(){
      //   if(!this.selectedcustomer){
      //     this.haserror.cust="Select Customer"
      //     this.barcode=''
      //   }else{
      //     this.haserror.cust=''
      //   }
      //   if(!this.selectshop){
      //     this.haserror.shop="Select Shop"
      //     this.barcode=''
      //   }else{
      //     this.haserror.shop=''
      //   }
      // },

      searchBarcode(){
        var option = {}
        var index = 0
        var addRow = 0
        var _this = this 
        var barcode = this.barcode
        this.barcode = ''
        if(barcode){
          this.$http.get('/api/purchasereturns/joinproduct2?barcode='+barcode).then(function (response) {
            if(response.data[0] != null){
              if(_this.rows.length == 0){
                _this.rows.push({productnamex:[],selectedproductid:'',unit:'',unitvalue:'',selectproductrow:null,price:'', qty:'',amt:'', cgst:0, sgst:0,igst:'',amttotal:0,batchmd1:'',serialmd1:'',percentagemd1:'', amtmd1:'', variantrow:'n/a', inclusive1:false, salepricemd1:0, is_adjustment:false, adjustment_list:[], adjusted:[], err_qty:'', err_price:'', err_sgst:'', err_cgst:'', err_igst:'',productExist:'',item_seq:''})
                _this.rows[0].productnamex.push(response.data[0])
                _this.rows[0].selectproductrow=response.data[0]
                option = response.data[0]
                index = 0 
                _this.openvariant(option,index)
              }else{
                for(var i = 0; i<_this.rows.length; i++){
                  if(_this.rows[i].selectproductrow == null){
                    _this.rows[i].productnamex.push(response.data[0])
                    _this.rows[i].selectproductrow=response.data[0]
                    option = response.data[0]
                    index = i 
                    _this.openvariant(option,index)
                    break;
                  }else if(_this.rows[i].selectproductrow.product_id == response.data[0].product_id){
                    _this.rows[i].qty = parseFloat(_this.rows[i].qty) + 1
                    option = _this.rows[i]
                    _this.price(i)
                    break; 
                  }else{
                    if(i == parseInt(_this.rows.length)-1){
                      _this.rows.push({ productnamex:[],selectedproductid:'',unit:'',unitvalue:'',selectproductrow:null,price:'', qty:'',amt:'', cgst:0, sgst:0,igst:'',amttotal:0,batchmd1:'',serialmd1:'',percentagemd1:'', amtmd1:'', variantrow:'n/a', inclusive1:false, salepricemd1:0, is_adjustment:false, adjustment_list:[], adjusted:[], err_qty:'', err_price:'', err_sgst:'', err_cgst:'', err_igst:'',productExist:'',item_seq:''})
                      var j = parseInt(i)+1
                      _this.rows[j].productnamex.push(response.data[0])
                      _this.rows[j].selectproductrow=response.data[0]
                      option = response.data[0]
                      index = j 
                      _this.openvariant(option,index)
                      break;
                    }
                  }
                }
              }
            }
          }).catch(function(error){
            console.log(error)
          })
        }
      },

      nameAndnumber (item) {
        return `${item.cust_cmp_name} - ${item.cust_cmp_phone}`
      },

      shopuser(){
        var _this=this
        this.$http.get('/api/shopusers').then(function(response){

        }).catch(function(error){
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit('SET_AUTH_USER', null)
            _this.$router.push('/');
          }
          if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
            localStorage.clear();
            _this.$store.commit('SET_AUTH_USER', null)
            _this.$router.push('/');
          }
        })
      },

      savevatiantmodal(index){

      },

      // gst_setup(){
      //   this.is_cs_gst = true
      //   this.is_i_gst = true
      //   // this.customer_gst = option1.cust_cmp_gst
      //   if (this.company_gst && this.customer_gst) {
      //     var company_gst = this.company_gst.substring(0, 2)
      //     var customer_gst = this.customer_gst.substring(0, 2)
      //     if (company_gst === customer_gst) {
      //       this.is_cs_gst = true
      //       this.is_i_gst = false
      //       this.csgstdisable = true
      //     } else {
      //       this.is_cs_gst = false
      //       this.is_i_gst = true
      //       this.igstdisable = false
      //     }
      //   } else if (this.company_gst) {
      //     this.is_cs_gst = true
      //     this.is_i_gst = true
      //     this.csgstdisable = false
      //     this.igstdisable = false
      //   } else if (!this.company_gst) {
      //     this.is_cs_gst = false
      //     this.is_i_gst = false
      //   }
      // },

      onSelectCust(option1, set_default){
        var _this = this
        this.customer1.name = null
        this.customer1.add = null
        this.customer1.city = null
        this.customer1.state = null
        this.customer1.pincode = null
        this.customer1.phone = null
        this.customer1.gst = null
        this.customer1.ship_id = null
        this.addr.length = 0
        this.$http.get('/api/customershippspecs?filter[where][customer_id]=' + option1.customer_id).then(function (response) {
          var addr_data = response.data['ship_dt']
          var state_dt = response.data['state_dt']
          var city_dt = response.data['city_dt']
          for (var i = 0; i < addr_data.length; i++) {
            if(set_default === true){
              if (parseInt(addr_data[i].shipp_id) === 1) {
                _this.customer1.name = addr_data[i].customer_name
                _this.customer1.add = addr_data[i].address
                _this.customer1.city = city_dt[addr_data[i].city]
                _this.customer1.state = state_dt[addr_data[i].state_code]
                _this.customer1.pincode = addr_data[i].pincode
                _this.customer1.phone = addr_data[i].contact_no
                _this.customer1.gst = addr_data[i].gst_no
                _this.customer1.ship_id = addr_data[i].shipp_id
                _this.customer_gst = addr_data[i].gst_no
                // _this.gst_setup()
              }
            }
            else{
              if(parseInt(addr_data[i].shipp_id) === parseInt(_this.ship_id)){
                _this.customer1.name = addr_data[i].customer_name
                _this.customer1.add = addr_data[i].address
                _this.customer1.city = city_dt[addr_data[i].city]
                _this.customer1.state = state_dt[addr_data[i].state_code]
                _this.customer1.pincode = addr_data[i].pincode
                _this.customer1.phone = addr_data[i].contact_no
                _this.customer1.gst = addr_data[i].gst_no
                _this.customer1.ship_id = addr_data[i].shipp_id
                _this.customer_gst = addr_data[i].gst_no
                // _this.gst_setup()
              }
            }
            _this.addr.push({ yname: addr_data[i].customer_name, yaddress: addr_data[i].address, ypincode: addr_data[i].pincode, ystate: state_dt[addr_data[i].state_code], ystateid: addr_data[i].state_code, ycityid: addr_data[i].city, ycity: city_dt[addr_data[i].city], yphn: addr_data[i].contact_no, chkship_id: addr_data[i].shipp_id, ygst: addr_data[i].gst_no})
            if(i === addr_data.length - 1){
              _this.set_taxforall()
            }
          }
        }).catch(function (error) {
            console.log(error)
          });
      },

      set_tax(tax_id,index){
        var _this = this
        var cust_id = this.customername.filter(function(item) { return item.customer_id === _this.customer_gst; });
        _this.customer_gst = cust_id.length == 0 ? _this.customer_gst :  cust_id[0].cust_cmp_gst
        this.$http.get('/api/taxrates/findOne?filter[where][tax_id]='+tax_id).then(function(response){
          if(_this.company_gst && _this.customer_gst){
            var company_gst = _this.company_gst.substring(0, 2)
            var customer_gst = _this.customer_gst.substring(0, 2)
            if(company_gst === customer_gst){
              _this.rows[index]['cgst'] = response.data.tax_cgst
              _this.rows[index]['sgst'] = response.data.tax_sgst
              _this.rows[index]['igst'] = 0.00
            }else{
              _this.rows[index]['cgst'] = 0.00
              _this.rows[index]['sgst'] = 0.00
              _this.rows[index]['igst'] = response.data.tax_igst
            }
          }else if(!_this.company_gst){
            // _this.rows[index]['inclusive1'] = true
            _this.rows[index]['cgst'] = 0.00
            _this.rows[index]['sgst'] = 0.00
            _this.rows[index]['igst'] = 0.00
          }else{
            _this.rows[index]['cgst'] = response.data.tax_cgst 
            _this.rows[index]['sgst'] = response.data.tax_sgst
            _this.rows[index]['igst'] = 0.00
          }
          _this.price(index)
        }).catch(function(err){
          console.log(err)
        });
      },

      set_taxforall(){
        var lst_tax_id = [];
        for(var i=0; i<this.rows.length;i++){
          var tax_id = typeof this.rows[i].selectproductrow === 'object' ? this.rows[i].selectproductrow.tax_gst_id : this.rows[i].productdetails[0].tax_gst_id
          lst_tax_id.push(tax_id)
        }
        
        var _this = this
        var cust_id = this.customername.filter(function(item) { return item.customer_id === _this.customer_gst; });
        _this.customer_gst = cust_id.length == 0 ? _this.customer_gst :  cust_id[0].cust_cmp_gst
        
        this.$http.get('/api/taxrates?filter={"where": {"tax_id": {"inq": ["'+ lst_tax_id.join('","') +'"]}}}').then(function(response){
          if(response.data.length > 0){
            var obj = {}
            for(var j=0;j<response.data.length;j++){
              obj[response.data[j].tax_id] = response.data[j]
            }
            
            if(_this.company_gst && _this.customer_gst){
              var company_gst = _this.company_gst.substring(0, 2)
              var customer_gst = _this.customer_gst.substring(0, 2)
              if(company_gst === customer_gst){
                _this.is_cs_gst = true
                _this.is_i_gst = false
                _this.csgstdisable = true
                for(var k=0;k<_this.rows.length;k++){
                  var tax_id = typeof _this.rows[k].selectproductrow === 'object' ? _this.rows[k].selectproductrow.tax_gst_id : _this.rows[k].productdetails[0].tax_gst_id
                  _this.rows[k]['cgst'] = obj[tax_id]['tax_cgst']
                  _this.rows[k]['sgst'] = obj[tax_id]['tax_sgst']
                  _this.rows[k]['igst'] = 0.00
                }
                _this.detail.igst = 0.000000
              }else{
                _this.is_cs_gst = false
                _this.is_i_gst = true
                _this.igstdisable = true
                for(var k=0;k<_this.rows.length;k++){
                  var tax_id = typeof _this.rows[k].selectproductrow === 'object' ? _this.rows[k].selectproductrow.tax_gst_id : _this.rows[k].productdetails[0].tax_gst_id
                  _this.rows[k]['cgst'] = 0.00
                  _this.rows[k]['sgst'] = 0.00
                  _this.rows[k]['igst'] = obj[tax_id]['tax_igst']
                }
                _this.detail.sgst = 0.000000
                _this.detail.cgst = 0.000000
              }
            }else if(!_this.company_gst){
              _this.is_cs_gst = false
              _this.is_i_gst = false
               for(var k=0;k<_this.rows.length;k++){
                _this.rows[k]['cgst'] = 0.00
                _this.rows[k]['sgst'] = 0.00
                _this.rows[k]['igst'] = 0.00
               }
               _this.detail.cgst = 0.000000
               _this.detail.sgst = 0.000000
               _this.detail.igst = 0.000000
              // _this.rows[index]['cgst'] = 0.00
              // _this.rows[index]['sgst'] = 0.00
              // _this.rows[index]['igst'] = 0.00
            }else{
               _this.is_cs_gst = true
               _this.is_i_gst = true
               _this.csgstdisable = false
               _this.igstdisable = false
               for(var k=0;k<_this.rows.length;k++){
                var tax_id = typeof _this.rows[k].selectproductrow === 'object' ? _this.rows[k].selectproductrow.tax_gst_id : _this.rows[k].productdetails[0].tax_gst_id
                if(parseFloat(_this.rows[k]['cgst']) <= 0.00 && parseFloat(_this.rows[k]['sgst']) <= 0.00 && parseFloat(_this.rows[k]['igst']) <= 0.00 ){
                  _this.rows[k]['inclusive1'] = false
                  _this.rows[k]['cgst'] = obj[tax_id]['tax_cgst']
                  _this.rows[k]['sgst'] = obj[tax_id]['tax_sgst']
                  _this.rows[k]['igst'] = 0.00
                }
                
              }
              if(parseFloat(_this.rows[0]['cgst']) <= 0.00 && parseFloat(_this.rows[0]['sgst']) <= 0.00){
                _this.detail.cgst = 0.000000
                _this.detail.sgst = 0.000000
              }
              else{
                _this.detail.igst = 0.000000
              }
            }

            for(var k=0;k<_this.rows.length;k++){
              _this.price(k)
            }
            // _this.price(index)
          } 
          else{
            alert('Something went wrong')
          }
        }).catch(function(err){
          console.log(err)
        });
      },

      // company_data(){
      //   this.company_gst = this.selectshop.shop_gst
      // },

      onSelectvariant(option){
        var _this = this
        var index = this.variantindex
        // this.rows[this.variantindex].variantrow = option.variant_value
        if(option.variant_value === 'No Variant') {
          this.rows[this.variantindex]['variantrow']='n/a'
        }
        else{
          this.rows[this.variantindex]['variantrow']=option.variant_value
        }
        this.smallmodal=false;
        // var curr_prod = this.rows[this.variantindex]['selectproductrow']['product_id']
        // var curr_var = this.rows[this.variantindex]['variantrow']
        
        // if(this.lst_prod_var.length > 0){
        //   if(this.lst_prod_var.indexOf(curr_prod+'_'+curr_var) !== -1){
        //     alert('Item - ' + this.rows[this.variantindex]['selectproductrow']['product_name'] + ' with variant ' + option.variant_value + ' already added above. Kindly select other product')
        //       this.rows[this.variantindex]['selectproductrow']=null;
        //       this.rows[this.variantindex]['variantrow']=null
        //       return
        //   }
        // }
        // this.lst_prod_var[this.variantindex] = curr_prod+'_'+curr_var
        var temprow = this.rows[this.variantindex]
        let prdctid = typeof temprow.selectproductrow === 'object' ? temprow.selectproductrow.product_id : temprow.selectproductrow
        var prdctdetails = typeof temprow.selectproductrow === 'object' ? temprow.selectproductrow : null
        var customer_gst = _this.customername.filter(function(item) {
          return item.customer_id === _this.selectedcustomer.customer_id; });
        _this.customer_gst = customer_gst[0].customer_id
        var row = this.rows[this.variantindex].selectproductrow
        _this.onSelect(row,this.variantindex)
        if(prdctdetails){
          if(prdctdetails.tax_gst_id){
            _this.set_tax(prdctdetails.tax_gst_id,_this.variantindex)
          }
        }
        this.checkInventory(index,prdctid,option.variant_value)
        this.price(index)
        
      },

      onSelect(option,index){
        var _this = this
        _this.rows[index]['inclusive1'] = false
        if(option != null){
          if(option.alt_product_id != undefined){
            // _this.show_tax(option,index)
            // _this.rows[index]['qty']=1
            _this.rows[index]['unit']=option.unit_name
            _this.rows[index]['unitvalue']=option.unit_id
            _this.rows[index]['selectedproductid']=option.variant_id
          }else{
            _this.rows[index]['selectedproductid']=''
            _this.rows[index]['unit']=''
            _this.rows[index]['unitvalue']=''
            _this.rows[index]['selectproductrow']=null
            _this.rows[index]['price']=''
            _this.rows[index]['qty']=''
            _this.rows[index]['amt']=''
            _this.rows[index]['cgst']=0
            _this.rows[index]['sgst']=0
            _this.rows[index]['igst']=''
            _this.rows[index]['amttotal']=0
            _this.rows[index]['batchmd1']=''
            _this.rows[index]['serialmd1']=''
            _this.rows[index]['percentagemd1']=''
            _this.rows[index]['amtmd1']=''
            _this.rows[index]['variantrow']='n/a'
            _this.rows[index]['inclusive1']=false
            _this.rows[index]['salepricemd1']=0
            _this.rows[index]['item_seq']=''
            _this.rows[index].showvariant = false
            _this.rows[index].novariant = false
          }
        }else{
          _this.rows[index]['selectedproductid']=''
          _this.rows[index]['unit']=''
          _this.rows[index]['unitvalue']=''
          _this.rows[index]['selectproductrow']=null
          _this.rows[index]['price']=''
          _this.rows[index]['qty']=''
          _this.rows[index]['amt']=''
          _this.rows[index]['cgst']=0
          _this.rows[index]['sgst']=0
          _this.rows[index]['igst']=''
          _this.rows[index]['amttotal']=0
          _this.rows[index]['batchmd1']=''
          _this.rows[index]['serialmd1']=''
          _this.rows[index]['percentagemd1']=''
          _this.rows[index]['amtmd1']=''
          _this.rows[index]['variantrow']='n/a'
          _this.rows[index]['inclusive1']=false
          _this.rows[index]['salepricemd1']=0
          
        }

      },
      
      updateshop(){
        this.loading = true
        var _this = this
        this.$http.post('/api/sales/updateShop?filter[where][sales_id]='+ this.sales_id +'&filter[where][old_shop_id]='+this.old_shop_id + '&filter[where][est_shop_id]=' + this.selectshop.est_shop_id).then(function (response) {

          if(response.status == 200){
            if(response.data.data == 'Successful'){
              _this.$route.params.shopId = _this.selectshop.est_shop_id
              setTimeout(function(){  _this.showSaleItems();  _this.smallmodal1 = false; _this.loading = false; }, 1000);
              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;                                 
              _this.haserror.message= 'Sales Updated Successfully';
              setTimeout(function(){ _this.haserror.message='';}, 3000);
            }
          }
        }).catch(function (error){});
      },

      checkInventory(index,pid,vid){
        var _this = this
        this.$http.get('/api/estshopinventories?filter[where][product_id]='+pid+'&filter[where][est_shop_id]='+this.selectshop.est_shop_id+'&filter[where][variant_id]='+vid).then(function (response){
          if(response.data.length > 1){
           let avqty = response.data.length == 1 ? '0' :  response.data[1].quantity
               // let price =  response.data.length == 1 ? '0' :  response.data[1].last_purprice_aft
               let price =  response.data.length == 1 ? '0' :  response.data[1].exp_sellprice_bft
               // let unit =  response.data.length == 1 ? '' :  response.data[1].unit_id     
               _this.rows[index]['avaqty']=avqty
               _this.rows[index]['priceqty']=price
                // _this.rows[index]['unit']=unit               
              }else{
               _this.rows[index]['avaqty']=0
               _this.rows[index]['priceqty']=0
                 // _this.rows[index]['unit']=0  
               }
             })
      },
      
      openvariant_on_product(row, index){
        if('product_id' in row.selectproductrow){
          this.openvariant(row,index)
        }
        else{
          return false
        }
      },

      openvariant(row,index){
        this.variantindex=index
        this.variantdata=null
        this.variantvalue=[]
        var _this=this
        // var prdctid = typeof row === 'object' ? row.product_id : row 
        // var prdctdetails = _this.allproduct.filter(function(item) { return item.product_id === prdctid; })
        var vrnt_id = row.selectproductrow == null ? row.variant_id : row.selectproductrow.variant_id
        if(vrnt_id != null && vrnt_id != undefined){
          this.smallmodal=true;
          this.$http.get('/api/variantvalues?filter[where][variant_id]='+vrnt_id).then(function (response){
            _this.variantvalue=response.data
            _this.variantvalue.unshift({company_id: "I2OCGLB", id: 0, regcity_code: "I2O", variant_id: "0", variant_value: "No Variant"})

          }).catch(function (error) {
          });
        }else{
          this.rows[this.variantindex].show = true
          this.rows[this.variantindex].show1 = false
          var option = {company_id: "I2OCGLB", id: 0, regcity_code: "I2O", variant_id: "0", variant_value: "No Variant"}
          this.onSelectvariant(option)
          this.smallmodal=false;
          // _this.variantvalue.unshift({company_id: "I2OCGLB1", id: 0, regcity_code: "MUM", variant_id: "0", variant_value: "n/a"})
        }
      },
      openmodal(test){
        this.largeModal=true
        this.indexval=test
        this.percentagemd='';
        this.amtmd='';
        if(this.rows[test]['percentagemd1']!=''){
          this.percentagemd=this.rows[test].percentagemd1;
        }
        if(this.rows[test].amtmd1!=''){
          this.amtmd=this.rows[test].amtmd1;
        }
        this.inclusive=this.rows[test].inclusive1;
      },

      addRow1(){
        this.rows.push({ productnamex:[],selectedproductid:null,unit:'',selectproductrow:null,price:'', qty:'',amt:'', cgst:0, sgst:0,igst:'',amttotal:0,percentagemd1:'', amtmd1:'',avaqty:'',variantrow:'n/a',show:false,priceqty:'', inclusive1:false, err_qty:'', err_price:'', err_sgst:'', err_cgst:'', err_igst:'',productExist:'',item_seq:''})
        this.selected_pytype = 'partial'
        this.selected_pymode = 'cash'
        this.parpay = true
      },

      removeElement(row,index) {
        // var r = confirm("Are you sure you want to permanently delete?");
        // if (r == true) {       
        //   this.rows.splice(index, 1);
        //   var _this = this
        //   var data={}
        //   data.suppliersid=this.selectedcustomer.customer_id
        //   data.shopid=this.selectshop.est_shop_id
        //   data.item_seq=row.item_seq
        //   data.total_discount=this.totaldis
        //   data.additional=this.detail.addition
        //   data.amt_before_tax=this.totalamt
        //   data.cgst=this.totalcgst
        //   data.sgst=this.totalsgst
        //   data.igst=this.totaligst
        //   data.taxamt=this.totaltax
        //   data.totalamtpay=this.totalamtpay
        //   data.sales_id = row.sales_id
        //   this.$http.post('/api/saledetails/update',data) .then(function (response) {
        //   }).catch(function(error){})
        // }

        if(this.rows[index].item_seq != ''){
          this.remove_rows.push(this.rows[index])
          this.rows.splice(index,1)
        }
        else{
          this.rows.splice(index,1)
          // this.loading = false
        }
        this.manage_pre_paid()
      },
      
      manage_pre_paid(){
        if (parseFloat(this.totalamtpreviouspaid) > parseFloat(this.totalamtpay)) {
          this.paychange('full')
          this.modechange('cash')
          // this.selected_pytype = 'full'
          // this.selected_pymode = 'cash'
          this.chng = (parseFloat(this.totalamtpreviouspaid) - parseFloat(this.totalamtpay)).toFixed(4)
          this.totalparamtreceived = ''
          //totalamtreceived shuld be disable
          this.totalamtreceived = ''
          this.totamtrecdis = true
        }
        else if (parseFloat(this.totalamtpreviouspaid) == parseFloat(this.totalamtpay)) {
          this.paychange('full')
          this.modechange('cash')
          this.chng = (parseFloat(this.totalamtpreviouspaid) - parseFloat(this.totalamtpay)).toFixed(4)
          this.totalparamtreceived = ''
          this.totalamtreceived = ''
          this.totamtrecdis = true
        }
        else {
          this.paychange('partial')
          this.modechange('cash')
          this.totalparamtreceived = ''
          this.bal = parseFloat(this.totalamtpay) - parseFloat(this.totalamtpreviouspaid)
          this.totamtrecdis = false
        }
      },

      async searchshops(){
        var _this = this
        var response = await this.$http.get('/api/shopusers/getShop')
        _this.shopname=response.data
        if(_this.shopname.length > 0){
          return Promise.resolve(true);
        }
      },


      searchprd3(searchText,index,row){
        // this.haserror.cust=''
        // this.haserror.shop=''
        // var status = 1
        
        // if(this.selectshop==null){
        //   status = 0
        //   this.haserror.shop="Please Select Shop"
        // }

        // if(this.selectedcustomer==null ){
        //   status = 0
        //   this.haserror.cust="Please Select Supplier"
        // }

        // if(status == 1){
          var shopid = this.selectshop.est_shop_id
          var _this=this

          this.$http.get('/api/purchasereturns/joinproduct2?data='+searchText).then(function (response) {
            row.productnamex=response.data

          }).catch(function (error) {

          });

        // }
      },

      onSelectShp(option){
        this.haserror.shop=''
        this.company_gst = this.selectshop.shop_gst
        this.set_taxforall()
        if(option == undefined){
          this.haserror.shop="Please Select Shop"
        }
        if(this.rows.length > 0){
          for (var i = 0; i < this.rows.length; i++) {
            var pid = typeof this.rows[i].selectproductrow === 'object' ? this.rows[i].selectproductrow.product_id : this.rows[i].selectproductrow
            var vid = this.rows[i].variantrow == null ? 'n/a' : this.rows[i].variantrow
            this.checkInventory(i,pid,vid)
          }
        }
      },
              
      async searchcustomer(){
        var _this = this
        var response = await this.$http.get('/api/customers')
        _this.customername = response.data
        if(_this.customername.length> 0){
          return Promise.resolve(true);      
        }
      },

              savemodal(val){
                var num=/^([0-9]{1,2}|100)$/
                var num1=/^[0-9]{1,12}$/
                var amt_reg = /^[0-9]\d{0,11}(\.\d{1,6})??$/

                this.haserror.amt=''
                this.haserror.dis=''
                
                if( this.percentagemd!='' && this.amtmd!=''){
                 this.haserror.amt="Any one of required"
               }
               else if(this.percentagemd!='' &&  num.test(this.percentagemd)==false){
                this.haserror.dis="Invalid Percentage"                       
              }
              else if(this.amtmd!='' && amt_reg.test(this.amtmd)==false){
                this.haserror.amt="Invalid Amount"                      
              }
              else if(parseFloat(this.amtmd)>parseFloat(this.rows[val]['amt'])){
                this.haserror.amt="Discount Amount Cannot Be Greater Than Provided Amount"  
              }
              else{
                this.rows[val]['batchmd1']=this.batchmd
                this.rows[val]['serialmd1']=this.serialmd
                this.rows[val]['percentagemd1']=this.percentagemd
                this.rows[val]['amtmd1']=this.amtmd
                this.rows[val]['inclusive1']=this.inclusive
                this.largeModal=false;
                this.price(val);
              }
            },

            discountadd(){

              var num=/^\d{1,12}(\.\d{1,6})?$/
              if(num.test(this.detail.addition)==false && this.detail.addition!='' ){
                this.detail.addition='';
                alert("Please Provide Valid Integer For Additional Discount");
              }

              this.err_totamtpay = '';
              if(parseFloat(this.detail.totalamtpay) < 0.00){
                // this.detail.addition='';
                this.err_totamtpay = 'Invalid Entry for Total Amount'
              }

              if(this.selected_pytype === 'partial'){
                if(this.totalparamtreceived !== ''){
                  this.bal = (parseFloat(this.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(4)
                }
              }
              else if(this.selected_pytype === 'full'){
                this.totalamtreceived = parseFloat(this.detail.totalamtpay).toFixed(4)
              }
           },

          price(index){    
            // console.log('price')
            var num=/^[0-9]{1,11}$/
            var price = /^\d{1,12}(\.\d{1,6})?$/
            var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,6})?$|^(50)?$/
            var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,6})?$|^(100)?$/
            var diff =0
            var temp_price = this.rows[index]['priceqty']
            var temp_avaqty = this.rows[index]['avaqty']

            if(igstexp.test(this.rows[index]['igst'])==false && this.rows[index]['igst']!==''){
              this.rows[index]['igst']=0
              this.rows[index]['err_igst'] = 'Invalid';
            }else if(parseFloat(this.rows[index]['igst'])<0){
              this.rows[index]['igst']=''
              this.rows[index]['err_igst'] = 'Invalid';
            }else{
              this.rows[index]['err_igst'] = '';
            }

            if(tax.test(this.rows[index]['sgst'])==false  && this.rows[index]['sgst']!==''){
              this.rows[index]['sgst']=0
              this.rows[index]['err_sgst'] = 'Invalid';
            }else if(parseFloat(this.rows[index]['sgst'])<0){
              this.rows[index]['sgst']=0
              this.rows[index]['err_sgst'] = 'Invalid';
            }else{
              this.rows[index]['err_sgst'] = '';
              this.rows[index]['cgst'] = this.rows[index]['sgst']
            }

            if(tax.test(this.rows[index]['cgst'])==false  && this.rows[index]['cgst']!=='' ){
              this.rows[index]['cgst']=0
              this.rows[index]['err_cgst'] = 'Invalid';
            }else if(parseFloat(this.rows[index]['cgst']) < 0){
              this.rows[index]['cgst']=0
              this.rows[index]['err_cgst'] = 'Invalid';
            }else{
              this.rows[index]['err_cgst'] = '';          
            }

            if(this.rows[index]['price']===''){
              this.rows[index]['err_price'] = 'Required';
            }else if(parseFloat(this.rows[index]['price'])<0){
              this.rows[index]['err_price'] = 'Invalid Price';
            }else if(price.test(this.rows[index]['price'])==false  && this.rows[index]['price']!=''){
              this.rows[index]['err_price'] = 'Invalid Price';
            }else{
              this.rows[index]['err_price'] = '';
            }

            if(this.rows[index]['qty']===''){
              this.rows[index]['err_qty'] = 'Required';
            }else if(parseFloat(this.rows[index]['qty'])<=0.00){
              this.rows[index]['err_qty'] = 'Invalid Quantity';
            }else if(price.test(this.rows[index]['qty'])==false  && this.rows[index]['qty']!=''){
              this.rows[index]['err_qty'] = 'Invalid Quantity';
            }else{
              this.rows[index]['err_qty'] = '';          
            }

            if(this.rows[index]['igst']!=='' && parseFloat(this.rows[index]['igst']) > 0.00){
              this.rows[index]['cgst'] = 0
              this.rows[index]['sgst'] = 0
              var igst_value = parseFloat(this.rows[index]['igst'])
            }
            else{
              this.rows[index]['igst']=0.00
              var igst_value = 0.00
            }

            // if(this.rows[index]['igst']!=''){
            //   if(this.rows[index]['igst']!="0.00" ){
            //     this.rows[index]['cgst'] = 0
            //     this.rows[index]['sgst'] = 0
            //     var igst_value = parseFloat(this.rows[index]['igst'])
            //   }else{
            //     this.rows[index]['igst']=''
            //     var igst_value = 0                
            //   }
            // }
            // else{
            //   this.rows[index]['igst']=''
            //   var igst_value = 0
            // }

            // if(tax.test(this.rows[index]['sgst'])==false  && this.rows[index]['sgst']!=0){
            // this.rows[index]['sgst']=0
            // this.rows[index]['err_sgst'] = 'Invalid';
            // }else if(parseFloat(this.rows[index]['sgst'])<0){
            // this.rows[index]['sgst']=0
            // this.rows[index]['err_sgst'] = 'Invalid';
            // }else{
            // this.rows[index]['err_sgst'] = '';
            // this.rows[index]['cgst'] = this.rows[index]['sgst']
            // }

            // if(tax.test(this.rows[index]['cgst'])==false  && this.rows[index]['cgst']!=0 ){
            // this.rows[index]['cgst']=0
            // this.rows[index]['err_cgst'] = 'Invalid';
            // }else if(parseFloat(this.rows[index]['cgst'])<0){
            // this.rows[index]['cgst']=0
            // this.rows[index]['err_cgst'] = 'Invalid';
            // }else{
            // this.rows[index]['err_cgst'] = '';          
            // }

            if(this.rows[index]['qty']!=='' && this.rows[index]['price']!==''){
              var qty = parseFloat(this.rows[index]['qty'])
              var price = parseFloat(this.rows[index]['price'])
              var total = qty*price;
            }else if(this.rows[index]['qty']!=='' && this.rows[index]['price']===''){
              var qty = parseFloat(this.rows[index]['qty'])
              var price = 0
              var total = qty*price;
            }else if(this.rows[index]['qty']==='' && this.rows[index]['price']!==''){
              var qty = 0
              var price = parseFloat(this.rows[index]['price'])
              var total = qty*price;
            }else{
              var qty = 0
              var price = 0
              var total = qty*price;              
            }

            if(this.rows[index]['percentagemd1']!=''){
              total=total-(total*this.rows[index]['percentagemd1'])/100
            }
            if(this.rows[index]['amtmd1']!=''){
              total=total-parseFloat(this.rows[index]['amtmd1'])
            }
            if(total!=undefined){
              if(this.rows[index]['inclusive1'] == false){
                this.rows[index]['amt']=total.toFixed(4);
                var amttotal=total+(this.rows[index]['sgst']*total)/100 + (this.rows[index]['cgst']*total)/100 + (igst_value*total)/100
                amttotal = amttotal.toFixed(4);
                this.rows[index]['amttotal']=amttotal
              }else if(this.rows[index]['inclusive1'] == true){
                amttotal = total.toFixed(4);
                this.rows[index]['amttotal']=amttotal
                var total_percentage = parseFloat(this.rows[index]['sgst']) + parseFloat(this.rows[index]['cgst']) + igst_value
                var bfttotal = (total * (100/(100 + total_percentage)))
                this.rows[index]['amt']=bfttotal.toFixed(4);
              }
            }
            this.manage_pre_paid();
          },

        finalsubmit(val){
          this.haserror.message=''
          // this.haserror.cust='';
          // this.haserror.shop='';
          
          var num=/^[0-9]{1,11}$/
          var price = /^\d{1,12}(\.\d{1,6})?$/
          var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/
          var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/
          var submit = 0
          var dtregex=/^[0-9]{1}$/
          var saleentry_date = new Date(this.saleentry_dt)
          var year1=saleentry_date.getFullYear()
          var month1=saleentry_date.getMonth()+1;
          var daycon=saleentry_date.getDate();

          if(dtregex.test(month1)==true){ var month1='0'+month1 }else{ var month1=month1 }
          if(dtregex.test(daycon)==true){ var day1='0'+daycon }else{ var day1=daycon }

          saleentry_date=year1+'-'+month1+'-'+day1
          
            for (var i = this.rows.length-1; i >=0;  i--) {
              if(this.rows[i].selectproductrow!=null){
                if(this.rows[i].price===''){
                  submit = 1
                  this.rows[i].err_price = 'Required';
                }else if(parseFloat(this.rows[i].price)<=0){
                  submit = 1
                  this.rows[i].err_price = 'Invalid Price';
                }else if(price.test(this.rows[i].price)==false  && this.rows[i].price!=''){
                  submit = 1
                  this.rows[i].err_price = 'Invalid Price';
                }

                if(this.rows[i].qty===''){
                  submit = 1
                  this.rows[i].err_qty = 'Required';
                }else if(parseFloat(this.rows[i].qty)<=0.00){
                  submit = 1
                  this.rows[i].err_qty = 'Invalid Quantity';
                }else if(price.test(this.rows[i].qty)==false  && this.rows[i].qty != ''){
                  submit = 1
                  this.rows[i].err_qty = 'Invalid Quantity';
                }

                if(igstexp.test(this.rows[i]['igst'])==false && this.rows[i]['igst']!=='' && parseFloat(this.rows[i]['igst']).toFixed(2) !== '0.00'){
                  this.rows[i]['igst']=''
                  this.rows[i]['err_igst'] = 'Invalid';
                  submit = 1
                }else if(parseFloat(this.rows[i]['igst'])<0){

                  this.rows[i]['igst']=''
                  this.rows[i]['err_igst'] = 'Invalid';
                  submit = 1
                }
                
                if(tax.test(this.rows[i]['cgst'])===false  && this.rows[i]['cgst']!=='' && parseFloat(this.rows[i]['cgst']) < 0.00){
                  this.rows[i]['cgst']=0
                  this.rows[i]['err_cgst'] = 'Invalid';
                  submit = 1
                }else if(parseFloat(this.rows[i]['cgst'])<0){
                  this.rows[i]['cgst']=0
                  this.rows[i]['err_cgst'] = 'Invalid';
                  submit = 1
                }

                if(tax.test(this.rows[i]['sgst'])==false  && this.rows[i]['sgst']!=='' && parseFloat(this.rows[i]['sgst']) < 0.00){
                  this.rows[i]['sgst']=0
                  this.rows[i]['err_sgst'] = 'Invalid';
                  submit = 1
                }else if(parseFloat(this.rows[i]['sgst'])<0){
                  this.rows[i]['sgst']=0
                  this.rows[i]['err_sgst'] = 'Invalid';
                  submit = 1
                }

              }
            }

            // var customer =  typeof this.selectedcustomer === 'object' ? this.selectedcustomer.customer_id : this.selectedcustomer
            // var shopid = typeof this.selectshop === 'object' ? this.selectshop.est_shop_id : this.selectshop
            // if((customer==undefined || customer== '')|| (shopid==undefined || shopid == '')){
            //   if(shopid == ''){
            //     this.haserror.shop="Please Select Shop"
            //   }
            //   if(customer == ''){
            //     this.haserror.cust="Please Select Customer"
            //   }

            // }else{
              for (var i = this.rows.length-1; i>=0;  i--) {
                if(!this.rows[i].selectproductrow){
                  this.rows.splice(i,1);
                }
              }
              this.err_totamtpay = '';
              if(this.rows.length==0){
                alert("Nothing to Save");
              }else{  
                // if(this.detail.totalamtpay===''){
                //   submit = 1
                //   alert("Nothing To Save");
                // }
                // else if(parseFloat(this.detail.totalamtpay)<0){
                //   submit = 1
                //   alert("Invalid Entry" )
                // }
                 if(parseFloat(this.detail.totalamtpay) < 0){
                  //  this.detail.addition='';
                  //  alert("Total Amount to Pay Cannot be Zero")
                    this.err_totamtpay = 'Invalid Entry for Total Amount'
                  }
                else{
                  if(submit == 0){
                   this.amt_rec = ''
                   this.fullamt_rec = ''
                   this.chequeno_validate = ''
                   this.chequedate_validate = ''
                   /* if(this.selected_pytype === 'full'){
                      if(parseInt(this.chng) < 0){
                        alert('Invalid Entry - Change Amt Cannot Be Negative - Please Select Valid Payment Type(i.e Partial)')
                        this.totalamtreceived = ''
                        this.chng = 0
                        return
                      }
                      this.detail.totalamtpendingpay = 0
                    }
                    else if(this.selected_pytype === 'partial'){
                      if(parseInt(this.bal) < 0){
                        alert('Invalid Entry - Balance Amount Cannot Be Negative - Please Select Valid Payment Type(i.e Full)')
                        this.totalparamtreceived = ''
                        this.bal = 0
                        return
                      }
                      this.detail.totalamtpendingpay = this.bal
                    }*/
                    var amount_pay = 0.0
                    if(this.selected_pytype === 'full'){
                      var chk_full=false
                      if(this.totalamtreceived !== '' && parseFloat(this.totalamtreceived) <= 0.00){
                        var paying = parseFloat(this.totalamtpreviouspaid) + parseFloat(this.totalamtreceived)
                        if(this.totalamtpay > paying){
                            // this.totalamtreceived = ''
                            this.fullamt_rec =  'Invalid Amount Received, please select payment type - partial'
                            // alert('Invalid Entry - Amount Received is less than Total Amount to Pay - Please Select Valid Payment Type(i.e Partial)')
                            chk_full=true
                        }
                        else{
                          this.fullamt_rec = ''
                        }
                      }
                      else if(parseFloat(this.chng) < 0.00){
                        if(this.totamtrecdis !== true){
                          alert('Invalid Entry - Change Amt Cannot Be Negative - Please Select Valid Payment Type(i.e Partial)')
                          this.totalamtreceived = ''
                          this.chng = 0
                          chk_full = true
                        }
                      }

                      if (this.selected_pymode == 'cheque' && this.cheque_no == '') {
                        this.chequeno_validate='Required'
                        chk_full=true
                      }
                      if (this.selected_pymode == 'cheque' && this.cheque_date == '') {
                        this.chequedate_validate ='Required'
                        chk_full=true
                      }
                      if (chk_full == true) {
                        return
                      }
                      else {
                        if(this.totamtrecdis === false){
                          amount_pay = this.totalamtreceived
                          this.detail.totalamtpendingpay = 0
                        }
                        else{
                          amount_pay = 0 - parseFloat(this.chng)
                          this.detail.totalamtpendingpay = 0
                        }
                      }
                      // this.detail.totalamtpendingpay = 0
                    }
                    else if(this.selected_pytype === 'partial'){
                      var chk_partial=false
                      if(parseFloat(this.totalparamtreceived) == 0 || this.totalparamtreceived == ''){
                       this.amt_rec = 'Required'
                       this.totalparamtreceived = ''
                       this.bal = 0
                       chk_partial=true
                     }
                     if(parseFloat(this.bal) < 0.00){
                      alert('Invalid Entry - Balance Amount Cannot Be Negative - Please Select Valid Payment Type(i.e Full)')
                      this.totalparamtreceived = ''
                      this.bal = 0
                      chk_partial=true
                    }
                    if (this.selected_pymode == 'cheque' && this.cheque_no == '') {
                      this.chequeno_validate='Required'
                      chk_partial=true
                    }
                    if (this.selected_pymode == 'cheque' && this.cheque_date == '') {
                      this.chequedate_validate='Required'
                      chk_partial=true
                    }
                    if (chk_partial == true) {
                      return
                    }
                    else {
                      this.detail.totalamtpendingpay = this.bal
                      amount_pay = this.totalparamtreceived
                    }
                    this.detail.totalamtpendingpay = this.bal
                  }
                  else{
                   this.detail.totalamtpendingpay = parseFloat(this.totalamtpay) - parseFloat(this.totalamtpreviouspaid)
                   amount_pay = 0.00
                 }

                 if(this.cheque_date != ''){
                  var daynum = /^[0-9]{1}$/
                  let date = new Date(this.cheque_date)
                  var year = date.getFullYear()
                  var month = date.getMonth()+1;
                  var day = date.getDate();

                  if(daynum.test(month)==true){
                    var month='0'+month
                  }else{
                    var month=month
                  }

                  if(daynum.test(day)==true){
                    var day='0'+day
                  }else{
                    var day=day
                  }
                  var dateval = year+'-'+month+'-'+day
                }else{
                  var dateval = null
                }
                this.loading=true  
                var data={}
                data.sale_entry_date=saleentry_date
                data.suppliersid=this.selectedcustomer.customer_id
                data.shopid=this.selectshop.est_shop_id
                data.ship_id = this.customer1.ship_id
                data.pur_items=this.rows
                data.remove_pur_items = this.remove_rows
                data.total_discount=this.detail.totprddis
                data.additional=this.detail.addition
                data.amt_before_tax=this.detail.tot
                data.cgst=this.detail.cgst
                data.sgst=this.detail.sgst
                data.igst=this.detail.igst
                data.taxamt=this.detail.taxamt
                data.totalamtpay=this.detail.totalamtpay
                data.sales_id = this.sales_id
                data.totalamtpendingpay = this.detail.totalamtpendingpay
                // data.totalamtpendingpay = this.detail.totalamtpendingpay
                data.pay = {'paytype': '', 'paymode': '', 'chqno': '', 'chqdt': '', 'amt': 0}
                data.pay.paytype = this.selected_pytype
                data.pay.paymode = this.selected_pymode
                data.pay.chqno = this.cheque_no
                data.pay.chqdt = dateval
                // data.pay.amt = parseFloat(this.detail.totalamtpay) - parseFloat(this.detail.totalamtpendingpay)
                data.pay.amt = amount_pay
                // this.loading = false
                var _this=this
                this.$http.post('/api/sales/editdata',data).then(function(rersponse){
                  _this.loading=false;
                  document.body.scrollTop = 0;
                  document.documentElement.scrollTop = 0;
                  _this.haserror.message= 'Sales Updated Successfully';
                  setTimeout(function(){ _this.haserror.message='';}, 2000);
                  // console.log(_this,selectedcustomer.customer_id)
                  if(val === ''){
                    _this.reset()
                    _this.$router.push('/sales/salesentry')  
                  }
                  else{
                      let routeData = _this.$router.resolve({name: 'Sale Invoice Pdf', query: {sid: _this.sales_id,cid:_this.selectedcustomer.customer_id}});
                      window.open(routeData.href, '_blank');
                      _this.reset()
                      _this.$router.push('/sales/salesentry')
                    }
                  }).catch(function (error) {
                    _this.loading=false;
                    document.body.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                    _this.haserror.message= 'There is something wrong! Please try again later';
                    setTimeout(function(){ _this.haserror.message='';}, 2000);
                    _this.reset()
                    console.log(error)
                });
                }
              }
            }
        // }
      },
      
      reset(){
        this.igstdisable=true
        this.csgstdisable=true
        this.selectedcustomer=null
        this.selectshop=null
        this.detail.totprddis=''
        this.detail.addition=''
        this.detail.tot=''
        this.detail.cgst=''
        this.detail.sgst=''
        this.detail.igst=''
        this.detail.taxamt=''
        this.detail.totalamtpay=''
        this.detail.totalamtpendingpay=''
        this.totalamtreceived=''
        this.chng=''
        this.bal=''
        this.cheque_no=''
        this.cheque_date=''
        this.selected_pymode='cash'
        this.selected_pytype='full'
        this.customer1.name = null
        this.customer1.add = null
        this.customer1.city = null
        this.customer1.state = null
        this.customer1.pincode = null
        this.customer1.phone = null
        this.customer1.gst = null
        this.company_gst = null
        this.customer_gst = null
        this.totamtrecdis = false
        this.saleentry_dt = new Date().toISOString().slice(0,10)
        for (var i = this.rows.length-1; i >=0;  i--) {
          this.rows.splice(i,1);
        }
        for (var i = 0; i <2; i++) {
         this.rows.push({ productqnamex:[],selectedproductid:null,unit:'',selectproductrow:null,price:'', qty:'',amt:'', cgst:0, sgst:0,igst:'',amttotal:0,percentagemd1:'', amtmd1:'',variantrow:'n/a',avaqty:'',show:false,show1:false,priceqty:'', inclusive1:false,err_qty:'', err_price:'', err_sgst:'', err_cgst:'', err_igst:'',productExist:'',item_seq:''})
       }
     }
   }
 }
</script>


// WEBPACK FOOTER //
// src/views/sales/editsales.vue